import React from 'react'
import Container from '../container/Container'

import Header from 'components/header/pageHeader/Header'
import OtherPagesNameList from './OtherPagesNameList'
import Audio from './Audio/Audio'

import { handleAboveType } from '../types'

interface SettingsProps {
  clickable: boolean
  unBlur: boolean
  colors: any
  handleAbove: handleAboveType
  handleAudio: any
  audio?: {
    sound: boolean
    music: boolean
    volume: string
  }
  customPages?: any
}
//   userSettings={userSettings}

export default function Settings({
  clickable,
  unBlur,
  handleAbove,
  colors,
  handleAudio,
  audio,
  customPages,
}: SettingsProps) {
  return (
    <Container unBlur={unBlur} backgroundColor={colors.primary}>
      <Header
        background={colors.secondary}
        borderColor={colors.secondary}
        textColor={colors.secondary}
        strokeColor={colors.tertiary}
        name='Settings'
        handleAbove={handleAbove}
        audio={audio}
      />
      <OtherPagesNameList
        clickable={clickable}
        handleAbove={handleAbove}
        audio={audio}
        customPages={customPages}
      />
      <Audio audio={audio} colors={colors} handleAudio={handleAudio} />
    </Container>
  )
}
